// src/stone/icons/CentClock.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CentClock = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10 16v-4h2v4c0 .246.225.737 1.204 1.227.92.46 2.26.773 3.796.773 1.535 0 2.876-.313 3.796-.773C21.775 16.737 22 16.246 22 16v-4h2v4c0 1.411-1.118 2.42-2.31 3.016-1.252.626-2.911.984-4.69.984s-3.438-.358-4.69-.984C11.118 18.42 10 17.41 10 16" }),
      /* @__PURE__ */ jsx("path", { d: "M10 20v-4h2v4c0 .246.225.737 1.204 1.227.92.46 2.26.773 3.796.773 1.535 0 2.876-.313 3.796-.773C21.775 20.737 22 20.246 22 20v-4h2v4c0 1.411-1.118 2.42-2.31 3.016-1.252.626-2.911.984-4.69.984s-3.438-.358-4.69-.984C11.118 22.42 10 21.41 10 20M13.205 10.773c-.98.49-1.205.981-1.205 1.227s.225.737 1.205 1.227c.92.46 2.26.773 3.795.773s2.876-.313 3.795-.773C21.775 12.737 22 12.246 22 12s-.225-.737-1.205-1.227c-.92-.46-2.26-.773-3.795-.773s-2.876.313-3.795.773m-.895-1.789C13.562 8.358 15.222 8 17 8s3.438.358 4.69.984C22.882 9.58 24 10.59 24 12s-1.118 2.42-2.31 3.016c-1.252.626-2.912.984-4.69.984s-3.438-.358-4.69-.984C11.118 14.42 10 13.41 10 12s1.118-2.42 2.31-3.016M9 4v5H4V7h3V4z" }),
      /* @__PURE__ */ jsx("path", { d: "M8 2a6 6 0 1 0 0 12h1v2H8a8 8 0 1 1 7.669-10.284l.285.958-1.918.57-.284-.958A6 6 0 0 0 8 2" })
    ]
  }
);
var CentClock_default = CentClock;

export {
  CentClock_default
};
